import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant qui réinitialise le scroll en haut de la page à chaque changement de route.
 * À placer à l'intérieur du BrowserRouter (souvent dans App.tsx).
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;

